import React, { useEffect, useRef, useState } from 'react';
import { STANDARD_ATTRIBUTES } from './tokenUtils';
import { http_get } from '../../../../utils/api_client';
import { API_ENDPOINTS } from '../../../../utils/endpoints';

// BL-080 — the "{ } Insert personalization" dropdown. Searchable, grouped
// Standard / Custom. Loads the company catalog from the endpoint, falling back
// to the built-in Standard list so it works in isolation. onInsert(key) fires
// when an attribute is chosen.
function TokenPicker({ open, onClose, onInsert }) {
  const [catalog, setCatalog] = useState({ standard: STANDARD_ATTRIBUTES, custom: [] });
  const [query, setQuery] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    let alive = true;
    http_get(API_ENDPOINTS.GET_PERSONALIZATION_ATTRIBUTES)
      .then(({ data }) => {
        if (alive && data) {
          setCatalog({ standard: data.standard || STANDARD_ATTRIBUTES, custom: data.custom || [] });
        }
      })
      .catch(() => {}); // graceful fallback to the built-in Standard list
    return () => { alive = false; };
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose?.(); };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open, onClose]);

  if (!open) return null;

  const q = query.trim().toLowerCase();
  const filter = (list) => (list || []).filter(
    (a) => a.label.toLowerCase().includes(q) || a.key.toLowerCase().includes(q),
  );
  const std = filter(catalog.standard);
  const cust = filter(catalog.custom);

  const item = (a) => (
    <button type="button" key={a.key} className="un-tokmenu__item" onClick={() => onInsert(a.key)}>
      <span>{a.label}</span>
      <code>{`{{${a.key}}}`}</code>
    </button>
  );

  return (
    <div className="un-tokmenu" ref={ref}>
      <div className="un-tokmenu__search">
        <input placeholder="Search attributes…" value={query} onChange={(e) => setQuery(e.target.value)} autoFocus />
      </div>
      {std.length > 0 && <div className="un-tokmenu__group">Standard</div>}
      {std.map(item)}
      {cust.length > 0 && <div className="un-tokmenu__group">Custom</div>}
      {cust.map(item)}
      {std.length === 0 && cust.length === 0 && <div className="un-tokmenu__empty">No attributes match.</div>}
    </div>
  );
}

export default TokenPicker;
